// extracted by mini-css-extract-plugin
export var numpadContainer = "_j5-1";
export var phoneButton = "_j5-0";